/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PhotoResource
 */
export interface PhotoResource {
    /**
     * 
     * @type {string}
     * @memberof PhotoResource
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PhotoResource
     */
    url?: string;
}

/**
 * Check if a given object implements the PhotoResource interface.
 */
export function instanceOfPhotoResource(value: object): value is PhotoResource {
    return true;
}

export function PhotoResourceFromJSON(json: any): PhotoResource {
    return PhotoResourceFromJSONTyped(json, false);
}

export function PhotoResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhotoResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'url': json['url'] == null ? undefined : json['url'],
    };
}

export function PhotoResourceToJSON(value?: PhotoResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'url': value['url'],
    };
}

